import { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { Megaphone } from "lucide-react";
import { api } from "@/lib/api";

export function AnnouncementStrip({ text, testid = "announcement-banner", fixed = true }) {
  const item = (k) => (
    <span key={k} className="inline-flex items-center gap-2 px-8"><Megaphone className="h-3.5 w-3.5" />{text}</span>
  );
  return (
    <div role="status" aria-label={`Announcement: ${text}`} data-testid={testid}
      className={`${fixed ? "fixed inset-x-0 top-0 z-50" : "relative rounded-lg"} h-7 overflow-hidden border-b border-[#39ff14]/30 bg-black`}>
      <div className="announce-track h-7 items-center text-xs font-bold tracking-wide text-[#39ff14] [text-shadow:0_0_8px_rgba(57,255,20,0.6)]">
        {item("a")}{item("b")}{item("c")}{item("d")}
      </div>
    </div>
  );
}

export function AnnouncementBanner() {
  const { data } = useQuery({ queryKey: ["announcement"], queryFn: () => api.get("/announcement").then((r) => r.data), refetchInterval: 60000 });
  const on = !!(data?.published && data.text);
  useEffect(() => {
    document.body.classList.toggle("has-banner", on);
    return () => { document.body.classList.remove("has-banner"); };
  }, [on]);
  return on ? <AnnouncementStrip text={data.text} /> : null;
}
